import {Injectable} from '@angular/core';
import swal from 'sweetalert2';

/**
 * Toast notifications.
 *
 * Backed by SweetAlert2 (already a project dependency) in toast mode. This
 * replaced the unmaintained, git-pinned `messenger` library (002/T016) while
 * preserving the public API below, so every consumer is unchanged.
 *
 * Note: `timeout` is in SECONDS (as the old messenger `hideAfter` was) and is
 * converted to milliseconds for SweetAlert2's `timer`.
 */
@Injectable()
export class NotificationService {
  private readonly toast = swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timerProgressBar: false,
    animation: false,
    customClass: {
      popup: 'swal-custom-body',
      container: 'swal-custom-body'
    }
  });

  showSuccess(message: string, timeout: number = 5, showCloseButton?: boolean): void {
    this.toast.fire({
      icon: 'success',
      title: message,
      timer: timeout * 1000,
      showCloseButton: !!showCloseButton,
    });
  }

  showError(message: string, timeout: number = 5, showCloseButton?: boolean): void {
    this.toast.fire({
      icon: 'error',
      title: message,
      timer: timeout * 1000,
      showCloseButton: !!showCloseButton,
    });
  }

  showWarning(message: string, timeout: number = 5, showCloseButton?: boolean): void {
    this.toast.fire({
      icon: 'warning',
      title: message,
      timer: timeout * 1000,
      showCloseButton: !!showCloseButton,
    });
  }

}
